import { service } from '../index.js'

// 设计管理
export const design = {
  // 列表
  list: ({ params = {} } = {}) => {
    return service.get('/design/admin/list', { params })
  },
  
  // 详情
  get: (params) => {
    return service.get(`/design/detail/${params.id}`)
  },
  
  // 添加
  add: (data) => {
    return service.post('/design/admin/add', data)
  },
  
  // 更新
  update: (data) => {
    return service.post('/design/admin/update', data)
  },
  
  // 更新状态（上下架）
  updateStatus: (data) => {
    return service.put(`/design/admin/status/${data.id}`, { status: data.status })
  },
  
  // 删除
  delete: (params) => {
    return service.delete(`/design/admin/${params.id}`)
  },
  
  // 审核通过
  approve: (data) => {
    return service.post('/design/admin/approve', data)
  },
  
  // 审核拒绝
  reject: (data) => {
    return service.post('/design/admin/reject', data)
  },

  // 更新封面
  updateCover: (data) => {
    return service.post('/design/admin/cover', data)
  },
  
  // 热门设计
  hot: (params) => {
    return service.get('/design/hot', params)
  }
}



// WEBPACK FOOTER //
// ./src/api/modules/design.js